import auslLogoMobile from '~/assets/img/ico-ausl.svg';
import banditsLogoMobile from '~/assets/img/ico-bandits.svg';
import blazeLogoMobile from '~/assets/img/ico-blaze.svg';
import talonsLogoMobile from '~/assets/img/ico-talons.svg';
import voltsLogoMobile from '~/assets/img/ico-volts.svg';
import auslLogo from '~/assets/img/logo-ausl.svg';
import banditsLogo from '~/assets/img/logo-bandits.svg';
import blazeLogo from '~/assets/img/logo-blaze.svg';
import talonsLogo from '~/assets/img/logo-talons.svg';
import voltsLogo from '~/assets/img/logo-volts.svg';

export const getLogo = (team?: string) => {
  switch (team?.toLowerCase()) {
    case 'bandits':
      return {
        icon: { ...banditsLogoMobile, altText: 'Bandits Logo' },
        logo: { ...banditsLogo, altText: 'Bandits Logo' },
      };
    case 'blaze':
      return {
        icon: { ...blazeLogoMobile, altText: 'Blaze Logo' },
        logo: { ...blazeLogo, altText: 'Blaze Logo' },
      };
    case 'talons':
      return {
        icon: { ...talonsLogoMobile, altText: 'Talons Logo' },
        logo: { ...talonsLogo, altText: 'Talons Logo' },
      };
    case 'volts':
      return {
        icon: { ...voltsLogoMobile, altText: 'Volts Logo' },
        logo: { ...voltsLogo, altText: 'Volts Logo' },
      };

    case 'blue':
    case 'orange':
    case 'yellow':
    case 'purple':
    case 'none':
      return undefined;

    default:
      return { icon: auslLogoMobile, logo: auslLogo };
  }
};
